






























































import Vue from "vue";
import { Getter, Mutation, Action } from "vuex-class";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import InfiniteLoading from "vue-infinite-loading";

import ProfileItem from "../components/ProfileItem.vue";
import Avatar from "../components/Avatar.vue";

import { Profile } from "../types";
import { SELECTED_USER, LOADING_ITEMS } from "../constants";

@Component({
  components: { ProfileItem, Avatar, InfiniteLoading },
})
export default class Home extends Vue {
  @Getter("profiles") profiles!: Profile[];
  @Getter("curProfile") curProfile!: Profile;

  @Mutation("SET_PROFILES") setProfiles: any;
  @Mutation("SET_CUR_PROFILE") setCurProfile: any;
  @Action("LOAD_PROFILES") loadProfiles: any;

  search = "";
  filteredProfiles: Profile[] = [];
  debounceInput: any = null;
  infiniteId = +new Date();

  @Watch("profiles")
  onProfilesChange(): void {
    this.filteredProfiles = this.profiles;
  }

  created(): void {
    this.filteredProfiles = this.profiles;
    this.setCurProfile(
      localStorage.getItem(SELECTED_USER)
        ? JSON.parse(localStorage.getItem(SELECTED_USER) || "")
        : null
    );
  }

  infiniteHandler(): void {
    this.searchProfile();
  }

  async searchHandle(): Promise<void> {
    this.setProfiles([]);
    clearTimeout(this.debounceInput);

    this.debounceInput = setTimeout(async () => {
      await this.searchProfile();
    }, 500);
  }

  async searchProfile(): Promise<void> {
    const search = this.search.toLowerCase();

    const profiles = await this.loadProfiles({ results: LOADING_ITEMS });

    if (search) {
      const filtered = await profiles.filter(
        (profile: Profile) =>
          profile.name.first.toLowerCase().includes(search) ||
          profile.name.last.toLowerCase().includes(search)
      );
      if (filtered.length > LOADING_ITEMS) filtered.length = LOADING_ITEMS;

      this.filteredProfiles = filtered;
    } else {
      this.filteredProfiles = profiles;
    }
  }

  selectProfile(profile: Profile): void {
    this.setCurProfile(profile);
  }

  get profileLocation(): string {
    if (this.curProfile) {
      const { location } = this.curProfile;
      return `${location.street.name} ${location.street.number}, ${location.city}, ${location.state}, ${location.country}`;
    }
    return "";
  }

  get profileTimezone(): string {
    if (this.curProfile) {
      const { location } = this.curProfile;
      return `${location.timezone.description} ${location.timezone.offset}`;
    }
    return "";
  }
}
